
import { Vue, Component, Prop } from 'vue-property-decorator';
import UiButton from '@/components/button/ui-button.vue';
import GET_PAYMENT_CARDS from '@/apollo/payment/GetPaymentCards.gql';
import { SubscriptionStatus } from '@/entities/payment/SubscriptionStatus';

import GET_PAYMENT_CARDS_ESSENTIAL from '@/apollo/payment/GetPaymentCardsEssential.gql';
import { Payment_Card } from '@/generated/graphql';

import { Company, User } from '@/generated/graphql';

@Component({
	components: {
		UiButton,
	},
	apollo: {
		paymentCardsFullInfo: {
			query: GET_PAYMENT_CARDS,
			variables() {
				return {
					userId: this.currentUser.id,
					subscriptionId: this.currentSubscriptionId,
				};
			},
			update(data) {
				this.paymentCards = data.payment_card;
			},
		},
	},
})
export default class BillingInfo extends Vue {
	@Prop({ type: Object, required: true }) readonly company!: Company;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: Object, required: true }) readonly subcription: any;

	paymentCards: Payment_Card[] = [];
	paymentDetails: Payment_Card | null = null;
	get currentSubscriptionId(): string {
		return this.currentUser.admin!.company.subscriptions[0]?.id;
	}
	get isTrialPeriod(): boolean {
		return (
			this.company.subscriptions[0]?.status === SubscriptionStatus.TRIALING
		);
	}
	get paymentCardsExist(): boolean {
		return this.paymentCards.length > 0;
	}
	get UserName(): string {
		return `${this.currentUser.given_name}  ${this.currentUser.family_name}`;
	}
	get getBillCurrentPeriodEndDate(): string {
		
		const periodEndTime = this.subcription!?.current_period_end;
		const formatedDate = new Date(periodEndTime * 1000);
		return formatedDate.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		});
	}
	created() {
		this.$apollo
			.query({
				query: GET_PAYMENT_CARDS_ESSENTIAL,
				variables: {
					userId: this.currentUser.id,
				},
				fetchPolicy: 'network-only',
			})
			.then((result) => {
				const payment: Payment_Card = result.data.payment_card[0];
				this.paymentDetails = {
					...payment,
				};
			})
			.catch(console.error);
	}
	refetch() {
		this.$apollo.queries.paymentCardsFullInfo.refetch();
	}
}
